export const healthStatuses = {
  RUNNING: {
    text: 'Running',
    color: 'GREEN',
  },
  NOT_RUNNING: {
    text: 'Not Running',
    color: 'RED',
  },
  GREEN: {
    text: 'Running',
    color: 'GREEN',
  },
  RED: {
    text: 'Not Running',
    color: 'RED',
  },
  ORANGE: {
    text: 'Partially Running',
    color: 'ORANGE',
  },
  GREY: {
    text: 'Unknown',
    color: 'GREY',
  },
};
